/*
 A middleware which will add asyncDispatch method to all actions and u could
 dispatch actions directly from reducer via asyncDispatch

 Example:

    function reducer(state, action) {
        switch (action.type) {
            case "fetch-start":
                fetch('wwww.example.com')
                .then(r => r.json())
                .then(r => action.asyncDispatch({ type: "fetch-response", value: r }))
                return state;

            case "fetch-response":
                return Object.assign({}, state, { whatever: action.value });;
        }
    }
 */

export const asyncDispatchMiddleware = (store) => (next) => (action) => {
    let syncActivityFinished = false;
    let actionQueue = [];

    function flushQueue() {
        actionQueue.forEach((a) => store.dispatch(a)); // flush queue
        actionQueue = [];
    }

    function asyncDispatch(asyncAction) {
        actionQueue = actionQueue.concat([asyncAction]);

        if (syncActivityFinished) {
            flushQueue();
        }
    }

    const actionWithAsyncDispatch = Object.assign({}, action, { asyncDispatch });

    const result = next(actionWithAsyncDispatch);
    syncActivityFinished = true;
    flushQueue();

    return result;
};
